import { IconProps } from "../../utils/global-types/global-types";

const DownloadIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M9.875 2.875a.874.874 0 1 0-1.75 0v6.636L6.118 7.504a.876.876 0 0 0-1.239 1.239l3.5 3.5a.876.876 0 0 0 1.239 0l3.5-3.5a.876.876 0 0 0-1.239-1.239L9.875 9.511zm-6.125 8.75c-.965 0-1.75.785-1.75 1.75v.875c0 .965.785 1.75 1.75 1.75h10.5c.965 0 1.75-.785 1.75-1.75v-.875c0-.965-.785-1.75-1.75-1.75h-2.775l-1.24 1.239a1.75 1.75 0 0 1-2.474 0l-1.236-1.239zm10.063 1.531a.656.656 0 1 1 0 1.312.656.656 0 0 1 0-1.312"
    ></path>
  </svg>
);

export default DownloadIcon;
